import React from "react";
import { format } from "date-fns";
import { CircularProgress } from "@/pages/dashboard/components/CircularProgress";

interface WaivedProgressCardProps {
    label: string;
    currentPoints: number;
    threshold: number;
    nextBillingDate?: string | null;
}

const WaivedProgressCard: React.FC<WaivedProgressCardProps> = ({
    label,
    currentPoints,
    threshold,
    nextBillingDate,
}) => {
    const progress = threshold > 0 ? (Math.min(currentPoints, threshold) / threshold) * 100 : 0;
    const pointsToGo = Math.max(threshold - currentPoints, 0);

    return (
        <div className="bg-white rounded-2xl px-6 py-5 shadow-sm w-full h-full flex flex-col">
            <p className="text-left text-xs font-semibold text-gray-500 uppercase tracking-wide">{label}</p>
            <div className="flex items-center justify-center mt-2 flex-1">
                <CircularProgress value={progress} size={110} strokeWidth={10}>
                    <div className="text-center">
                        <p className="text-2xl font-bold text-gray-900">{currentPoints.toLocaleString()}</p>
                        <p className="text-[10px] text-gray-400 tracking-wide">PTS</p>
                    </div>
                </CircularProgress>
                <div className="text-right space-y-1.5 pl-3">
                    <p className="text-left text-sm font-semibold text-gray-900 leading-snug">
                        {pointsToGo > 0
                            ? `You are ${pointsToGo.toLocaleString()} points to go!`
                            : "Your next subscription fee has been waived!"}
                    </p>
                    <p className="text-left text-xs text-gray-400">Target: {threshold.toLocaleString()} points</p>
                    {nextBillingDate && (
                        <p className="text-xs text-gray-400">
                            Next Billing Date:{" "}
                            <span className="font-semibold text-gray-700">
                                {format(new Date(Number(nextBillingDate) * 1000), "MMM d, yyyy")}
                            </span>
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default WaivedProgressCard;
